module.exports = __webpack_public_path__ + "static/media/new-vision.5a4b98a2.png";